module.exports = __webpack_public_path__ + "static/media/task-square-white.0951bbfe.svg";